import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import { useContext, useMemo } from 'react';
import { StylesContext, mergeTokens } from '@rexlabs/element-styles';
export default function useModeTokens(baseTokens, modeTokens) {
  var _useContext = useContext(StylesContext),
      modes = _useContext.modes;

  return useMemo(function () {
    var _context;

    return _reduceInstanceProperty(_context = _filterInstanceProperty(modeTokens).call(modeTokens, function (_ref) {
      var mode = _ref.mode;
      return modes[mode];
    })).call(_context, function (acc, _ref2) {
      var tokens = _ref2.tokens;
      return mergeTokens(tokens, acc);
    }, baseTokens);
  }, [baseTokens, modeTokens, modes]);
}